import Tag from './Tag';

export { StyledTag } from './Tag';
export type { TagProps } from './Tag';
export { default as Wrapper } from './Wrapper';

export default Tag;
